import React, { useRef, useState, useEffect } from 'react';
import {
  CaretRightOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  CloseCircleOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';
import {
  Button,
  Collapse,
  Form,
  Input,
  Alert,
  Timeline,
  Space,
  Modal,
  Badge,
  theme,
  Pagination,
  Layout,
  Row,
  Col,
  Table,
} from 'antd';
import { formatDate } from '../../../common/utility';
import UserService from '../../../services/user.service';
import ScaleLoader from 'react-spinners/ScaleLoader';
import CustomSideBar from '../inc/CustomSideBar';
import TopBar from '../inc/TopBar';
import { List } from 'antd';
import { Checkbox, Divider } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import 'dayjs/locale/zh-cn';
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import { Tooltip } from '@mui/material';
import { ExportExcel } from '../../../library/Excelexport';
import { generatePDF } from '../../../library/PDFexport';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import { SearchOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';
import Highlighter from 'react-highlight-words';
type DataIndex = keyof orderData;

interface timeline {
  children: string;
  label: string;
}

const { Content } = Layout;
const { Panel } = Collapse;

interface Track {
  id: number;
  address: string;
  arrivalTime: string;
}
interface orderData {
  key: number;
  farmerName: string;
  destinationAddress: string;
  phone: string;
  supplierName: string;
  itemName: string;
  agentName: string;
  orderReference: string;
  quantity: number;
  totalAmount: number;
  createdAt: string;
  status: string;
}

const RiderComponent: React.FC = (props) => {
  const [message, setMessage] = useState('');
  const [form] = Form.useForm();
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPageActivity] = useState(1);
  const [submitBadge, setSubmitBadge] = useState('error');
  const [submitTitle] = useState('');
  const [submitMessage] = useState('');
  const [PageLoaded, setPageLoaded] = useState(false);
  const [isopenModal, setIsopenModal] = useState(false);
  const [cannotSubmit, setCanNotSubmit] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState('Dispatched');
  const [selectedOrder, setSelectedOrder] = useState<number>(0);
  const [orderData, setOrderData] = useState<orderData[]>([]);
  const [orderTrack, setOrderTrack] = useState<Track[]>([]);
  const [TrackTimeline, setTrackTimeline] = useState<timeline[]>([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [address, setAddress] = useState('');
  const [checkedSearch, setCheckedSearch] = useState<CheckboxValueType[]>([]);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [isMobile, setIsMobile] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);

  const [search, setSearch] = useState<string>();
  const [showDate, SetshowDate] = useState(false);
  const plainOptions = [
    { label: 'Item Name' },
    { label: 'Farmer Name' },
    { label: 'orderReference' },
    { label: 'order Phone' },
  ];
  const pageSize: number = 10;
  const { token } = theme.useToken();
  const onClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {};

  const handleAdd = () => {
    setSubmitting(true);
    form.validateFields().then((values) => {
      values.itemOrderID = selectedOrder;
      UserService.PostRecord(values, 'track-order').then(
        (response) => {
          setMessage('Order Path Set!');
          setSubmitBadge('success');
          setStatus('Dispatched');
          LoadOrderTrack();
          setSubmitting(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setMessage(resMessage);
          setSubmitting(false);
        }
      );
    });
  };
  const LoadData = () => {
    const searchParams = new URLSearchParams();
    checkedSearch.map((query: any) => searchParams.append('checked[]', query));
    const queryString = searchParams.toString();
    let searchurl = search
      ? `order?search=${search}&${queryString}&status=${status}`
      : `order?status=${status}`;

    const formattedStartDate = showDate
      ? format(dateRange[0].startDate, 'yyyy-MM-dd')
      : '';
    const formattedEndDate = showDate
      ? format(dateRange[0].endDate, 'yyyy-MM-dd')
      : '';
    searchurl = showDate
      ? `${searchurl}&fromDate=${formattedStartDate}&toDate=${formattedEndDate}`
      : searchurl;
    UserService.GetRecord(searchurl).then(
      (result) => {
        if (result.data) {
          setTotalData(result.data.data.length);
          setOrderData(
            result.data.data.map((option: any) => ({
              key: option.id,
              farmerName:
                option.Farmer.first_name + ' ' + option.Farmer.last_name,
              destinationAddress: option.OrderDetail.destinationAddress,
              phone: option.OrderDetail.phone,
              supplierName: option.supplierItem
                ? option.supplierItem.User.first_name +
                  ' ' +
                  option.supplierItem.User.last_name
                : '',
              itemName: option.Item.name,
              agentName: option.User.first_name + ' ' + option.User.last_name,
              orderReference: option.orderReference,
              quantity: option.quantity,
              createdAt: formatDate(option.createdAt),
              status: option.status,
            }))
          );
        }
      },
      (error) => {
        setOrderData([]);
      }
    );
  };
  const LoadOrderTrack = () => {
    UserService.GetRecord('track-order/' + selectedOrder).then(
      (result) => {
        if (result.data) {
          setOrderTrack(
            result.data.data.map((option: any) => ({
              id: option.id,
              address: option.address,
              arrivalTime: option.arrivalTime,
            }))
          );
          setTrackTimeline(
            result.data.data.map((option: any) => ({
              children: option.address,
              label: option.arrivalTime,
            }))
          );
        }
      },
      (error) => {
        setOrderTrack([]);
      }
    );
  };

  const handleCancel = () => {
    setIsopenModal(false);
  };

  const panelStyle = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  const searchItem: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  useEffect(() => {
    LoadData();
  }, [status, dateRange, search,LoadData]);
  const onsearchChange = (checkedValues: any) => {
    setCheckedSearch(checkedValues);
  };

  const handleTrackAddress = (editData: any) => {
    setIsopenModal(true);
    setSelectedOrder(editData.key);
    form.setFieldsValue({
      arrivalTime: null,
      address: '',
    });
  };

  useEffect(() => {
    address != null && selectedDate != ''
      ? setCanNotSubmit(false)
      : setCanNotSubmit(true);
  }, [address, selectedDate]);
  useEffect(() => {
    LoadOrderTrack();
  }, [selectedOrder]);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<orderData> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined rev="icon-rev" />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined
        rev="icon-rev"
        style={{ color: filtered ? '#1890ff' : undefined }}
      />
    ),
    onFilter: (value, record: any) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);
  }, []);
  const columns: ColumnsType<orderData> = [
    {
      title: 'Farmer Name',
      dataIndex: 'farmerName',
      key: 'farmerName',
      width: '30%',
      ...getColumnSearchProps('farmerName'),
    },
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      key: 'itemName',
      width: '20%',
      ...getColumnSearchProps('itemName'),
    },
    {
      title: 'Supplier Name',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: '20%',
      ...getColumnSearchProps('supplierName'),
    },
    {
      title: 'Agent Name',
      dataIndex: 'agentName',
      key: 'agentName',
      width: '20%',
      ...getColumnSearchProps('agentName'),
    },
    {
      title: 'Order Reference',
      dataIndex: 'orderReference',
      key: 'orderReference',
      width: '20%',
      ...getColumnSearchProps('orderReference'),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '20%',
      ...getColumnSearchProps('quantity'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '20%',
      ...getColumnSearchProps('status'),
    },
    {
      title: 'Action',
      dataIndex: 'key',
      key: 'key',
      width: '20%',
      render: (_: any, record: orderData) => (
        <Space>
          <Button
            onClick={(e) => {
              handleTrackAddress(record);
            }}
          >
            Set Tracking Address
          </Button>
        </Space>
      ),
    },
  ];

  // Define a function to render a page of data
  const renderPage = (pageData: any, page: string) => {
    return (
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rev="icon-rev" rotate={isActive ? 90 : 0} />
        )}
        style={{ background: token.colorBgContainer }}
      >
        {pageData.map((option: any, index: number) => (
          <Panel
            header={option.farmerName + ' ' + option.createdAt}
            key={index}
            style={panelStyle}
          >
            <List
              size="small"
              footer={
                <>
                  <Space>
                    <Button
                      onClick={() => {
                        handleTrackAddress(option);
                      }}
                    >
                      Set Tracking Address
                    </Button>
                  </Space>
                </>
              }
              dataSource={[
                'Item : ' + option.itemName,
                'Quantity : ' + option.quantity,
                'Reference : ' + option.orderReference,
                'Phone : ' + option.phone,
                'Address : ' + option.destinationAddress,
                'Supplier :' + option.supplierName,
                'Agent :' + option.agentName,
                'Status : ' + (option.status === 'pending') ? (
                  <Badge status="warning" text={option.status} />
                ) : option.status === 'rejected' ? (
                  <Badge status="error" text={option.status} />
                ) : option.status === 'completed' ? (
                  <Badge text={option.status} status="success" />
                ) : (
                  <Badge text={option.status} status="processing" />
                ),
              ]}
              bordered
              renderItem={(item: any) => <List.Item>{item}</List.Item>}
            />
          </Panel>
        ))}
      </Collapse>
    );
  };
  const removeAddress = (addressID: number) => {
    UserService.DeleteRecord('track-order/' + addressID).then(
      (response) => {
        setMessage('Order Path Deleted!');
        setSubmitBadge('success');
        setStatus('Dispatched');
        LoadOrderTrack();
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setMessage(resMessage);
      }
    );
  };
  const handleDateRangeChange = (ranges: any) => {
    setDateRange([ranges.selection]);
  };
  const useDateHandler = () => {
    SetshowDate(!showDate);
  };

  return (
    <>
      {PageLoaded ? (
        <div className="App">
          <Layout style={{ minHeight: '100vh' }}>
            <CustomSideBar />
            <Layout className="site-layout">
              <TopBar />
              <Content style={{ margin: '20px' }}>
                <>
                  <Modal
                    title="Dispatch Order"
                    open={isopenModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="back" onClick={handleCancel}>
                        Return
                      </Button>,
                    ]}
                  >
                    <Space>
                      {message && submitBadge === 'success' && (
                        <Alert
                          message="Success"
                          description={message}
                          type="success"
                          closable
                          onClose={onClose}
                        />
                      )}
                      {message && submitBadge === 'error' && (
                        <Alert
                          message="Error"
                          description={message}
                          type="error"
                          closable
                          onClose={onClose}
                        />
                      )}
                    </Space>
                    <Form form={form}>
                      <Space>
                        {submitMessage && submitBadge === 'success' && (
                          <Alert
                            message={submitTitle}
                            description={submitMessage}
                            type="success"
                            closable
                            onClose={onClose}
                          />
                        )}
                        {submitMessage && submitBadge === 'error' && (
                          <Alert
                            message={submitTitle}
                            description={submitMessage}
                            type="error"
                            closable
                            onClose={onClose}
                          />
                        )}
                      </Space>
                      <Form.Item
                        name="arrivalTime"
                        label="Expected  Arrival"
                        rules={[
                          {
                            required: true,
                            message: 'Please input Arrival Time!',
                          },
                        ]}
                      >
                        <Input
                          type="datetime-local"
                          style={{ width: 'auto' }}
                          value={selectedDate || ''}
                          onChange={(e) => setSelectedDate(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        name="address"
                        label="Address"
                        rules={[
                          { required: true, message: 'Please input Address!' },
                        ]}
                      >
                        <Input
                          placeholder="Type Address"
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </Form.Item>
                      <Button
                        key="submit"
                        onClick={handleAdd}
                        type="primary"
                        loading={submitting}
                        disabled={cannotSubmit}
                      >
                        Add
                      </Button>

                      <Alert
                        showIcon={false}
                        message="Address shows order of delivery from top to bottom"
                        banner
                        style={{ margin: '10px' }}
                      />
                      {orderTrack.map((data) => (
                        <Input
                          addonBefore={
                            <Button
                              type="dashed"
                              danger
                              onClick={() => {
                                removeAddress(data.id);
                              }}
                            >
                              <CloseCircleOutlined rev="icon-rev" />
                            </Button>
                          }
                          readOnly={true}
                          style={{ margin: '5px' }}
                          defaultValue={data.address}
                        />
                      ))}
                      {orderTrack && <h2> Delivery Time Line</h2>}
                      <Timeline mode="left" items={TrackTimeline} />
                    </Form>
                  </Modal>
                  <p>
                    <div
                      id="range-picker-container"
                      className="range-picker-container"
                    >
                      {showDate && (
                        <>
                          <p>
                            <DateRange
                              ranges={dateRange}
                              onChange={handleDateRangeChange}
                            />
                          </p>
                        </>
                      )}
                      <Button type="primary" onClick={useDateHandler}>
                        {showDate ? 'Hide Date' : 'Search Date Range'}
                        <FieldTimeOutlined rev="icon-rev" />
                      </Button>
                    </div>
                    <div style={{ overflowX: 'auto' }}></div>
                    <Divider />
                    <Tooltip title="Export Excel">
                      <Button
                        onClick={() => {
                          ExportExcel({
                            excelDelta: orderData,
                            fileName: 'orderDetails',
                          });
                        }}
                      >
                        Export Excel
                        <FileExcelOutlined rev="icon-rev" />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Export Excel">
                      <Button
                        onClick={() => {
                          generatePDF();
                        }}
                      >
                        Export PDF
                        <FilePdfOutlined rev="icon-rev" />
                      </Button>
                    </Tooltip>
                    {isMobile && (
                      <>
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={onsearchChange}
                        >
                          <Row>
                            {plainOptions.map((plainOptionData, index) => (
                              <Col span={8} key={index}>
                                <Checkbox
                                  value={plainOptionData.label.replaceAll(
                                    ' ',
                                    ''
                                  )}
                                >
                                  {plainOptionData.label}
                                </Checkbox>
                              </Col>
                            ))}
                          </Row>
                        </Checkbox.Group>
                        <div />
                        <Input
                          style={{ margin: '5px' }}
                          placeholder="Search Order"
                          onChange={searchItem}
                        />
                      </>
                    )}
                  </p>
                  <div id="report">
                    {!isMobile ? (
                      <Table columns={columns} dataSource={orderData} />
                    ) : (
                      <>
                        {/* Render the current page of data */}
                        {renderPage(
                          orderData.slice(
                            (currentPage - 1) * pageSize,
                            currentPage * pageSize
                          ),
                          'order'
                        )}
                        {/* Render pagination component */}
                        <Pagination
                          total={totalData}
                          pageSize={pageSize}
                          current={currentPage}
                          onChange={(page) => setCurrentPageActivity(page)}
                        />
                      </>
                    )}
                  </div>
                </>
              </Content>
            </Layout>
          </Layout>
        </div>
      ) : (
        <div className="login-form-wrapper">
          <ScaleLoader
            color={'#fff'}
            loading={!PageLoaded}
            // size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </>
  );
};
export default RiderComponent;
